// Singleton instances — import from here throughout the app
import { AuthService } from "./services/AuthService";
import { InstagramService } from "./services/InstagramService";
import { AutomationService } from "./services/AutomationService";
import { SubscriptionService } from "./services/SubscriptionService";
import { LogService } from "./services/LogService";
import { RulesService } from "./services/RulesService";
import { CommentService } from "./services/CommentService";

export const authApi = new AuthService();
export const instagramApi = new InstagramService();
export const automationApi = new AutomationService();
export const subscriptionApi = new SubscriptionService();
export const logApi = new LogService();
export const rulesApi = new RulesService();
export const commentApi = new CommentService();

// Re-export types
export type { User, Plan, InstagramAccount, Automation, Subscription, LogEntry, LogStats, Post } from "./types";
export type { ReplyRule } from "./services/RulesService";
export type { Trigger, Listener, Keyword } from "./types";
export type { InstagramComment } from "./services/CommentService";
